import React from 'react';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';

export interface LogotypeProps {
    color?: string;
    width?: string | (string | null)[];
    height?: string | (string | null)[];
}

export const Logotype = ({ color = 'currentColor', width, height, ...rest }: LogotypeProps) => (
    <Svg width={width} height={height} viewBox="0 0 72 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <Path fill={color} d="M0 39.399H4.62723V23.0648H11.5608V18.8518H4.62723V4.88976H11.8328V0.601033H0V39.399Z" />
        <Path
            fill={color}
            d="M21.3432 0C17.2512 0 13.8408 3.53635 13.8408 8.57746V31.4225C13.8408 36.5393 17.2512 40 21.3432 40C25.4352 40 28.8456 36.5393 28.8456 31.4225V8.57746C28.8456 3.53635 25.4352 0 21.3432 0ZM24.2988 32.3248C24.2988 34.0552 23.1625 35.41 21.3432 35.41C19.5239 35.41 18.3876 34.0552 18.3876 32.3248V7.67373C18.3876 6.01906 19.4478 4.58852 21.3432 4.58852C23.2385 4.58852 24.2988 6.01761 24.2988 7.67373V32.3248Z"
        />
        <Path fill={color} d="M53.5642 0.601033H48.9062V39.399H53.5642V0.601033Z" />
        <Path
            fill={color}
            d="M39.1019 0C35.0084 0 31.598 3.53635 31.598 8.57746V31.4225C31.598 37.5173 35.3112 40 38.1922 40C39.9867 40 41.531 39.3801 42.5504 38.2347V38.2435C42.5562 38.6306 42.5986 39.0177 42.6747 39.3975H46.151V18.8663H39.1019V23.0794H42.0575V32.3263C42.0575 34.4335 41.0733 35.7869 39.1019 35.7869C37.1305 35.7869 36.1462 34.4321 36.1462 32.3263V7.67373C36.1462 6.01906 37.208 4.58852 39.1019 4.58852C40.9958 4.58852 42.0575 6.01761 42.0575 7.67373V15.0404H46.151V8.57746C46.151 3.53635 43.1953 0 39.1019 0Z"
        />
        <Path
            fill={color}
            d="M67.3684 0.601033H60.0005L55.4142 39.399H60.037L61.0388 29.129H66.3856L67.3772 39.399H72L67.3684 0.601033ZM61.4513 24.9145L63.6537 5.67998H63.8424L65.982 24.9145H61.4513Z"
        />
    </Svg>
);
